// @ts-check
import RequestService from './request-service';

/**
 * Combined Slider Request Service
 */
export default class CombinedSliderRequestService extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.combinedSlider;
    /**
     * Set request method
     * @type {string}
     */
    this.method = 'get';

    /**
     * Set get params
     * @type {{platform: import('bto-models/combined-slider/interface').ICombinedSliderPlatform, culture: string}}
     */
    this.getParams = {
      PlatformID: getCombinedSliderPlatform(),
      Culture: APP_SETTINGS.player.language || 'en',
      TimeOffset: new Date().getTimezoneOffset(),
      ExternalUserID: APP_SETTINGS.player.id || null,
      LocalCurrency: APP_SETTINGS.player.currency || null,
    };
    this.headers = null;
  }
}

function getCombinedSliderPlatform() {
  if (process.env.VUE_APP_IS_MOBILE) {
    return 2;
  }
  if (process.env.VUE_APP_IS_AGENT) {
    return 4;
  }
  if (APP_SETTINGS && APP_SETTINGS.settings && APP_SETTINGS.settings.isSSBT) {
    return 3;
  }
  return 1;
}